"use strict";

angular.module("internal.licenses", ['ngAnimate', 'ui.bootstrap'])
    .config([
    "$stateProvider",
        function ($stateProvider) {
        $stateProvider
        // Internal routings
        // Licenses tab
        .state("internal.licensing.licenses", {
            url: "/licenses",
            templateUrl: paths.app + "licenses/components/licenses/licenses.html",
            controller: "InternalLicenses",
            resolve: {
                permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                    $rootScope.$state.current = this.self;
                    return Permissions.view(this.self.name).then(function (access) {
                        if (!access) {
                            $state.go("internal.licensing.denied");
                        }
                    });
                }]
            }
        })
        .state("internal.licensing.license", {
            abstract: true,
            templateUrl: paths.app + "licenses/components/license/license.html",
            controller: "InternalLicense",
            params: {
                id: null,
                license: null
            }
        })

            //Details
            .state("internal.licensing.license.details", {
                abstract: true,
                templateUrl: paths.app + "licenses/layouts/license-details.html"
            })
                .state("internal.licensing.license.details.details", {
                    url: "/license/:id",
                    templateUrl: paths.app + "licenses/components/license-details/license-details.html",
                    controller: "InternalLicenseDetails",
                    params: {
                        id: null,
                        license: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.id == null) {
                                method = "add";
                            }
                            return Permissions[method](this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.details.statuseslevels", {
                    url: "/license/:id/statuseslevels/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-statuseslevels/license-statuseslevels.html",
                    controller: "InternalLicenseStatusesLevels",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.details.attributes", {
                    url: "/license/:id/attributes/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-attributes/license-attributes.html",
                    controller: "InternalLicenseAttributes",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.details.applicationtypes", {
                    url: "/license/:id/applicationtypes/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-applicationtypes/license-applicationtypes.html",
                    controller: "InternalLicenseApplicationTypes",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view("internal.licensing.license.details.details").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })

            //Workflow
            .state("internal.licensing.license.workflow", {
                url: "/license/:id/workflow",
                templateUrl: paths.app + "licenses/components/license-workflow/license-workflow.html",
                controller: "InternalLicenseWorkflow",
                params: {
                    id: null,
                    license: null
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })

            //Forms 
            .state("internal.licensing.license.forms", {
                abstract: true,
                templateUrl: paths.app + "licenses/layouts/license-forms.html"
            })
                .state("internal.licensing.license.forms.forms", {
                    url: "/license/:id/forms",
                    templateUrl: paths.app + "licenses/components/license-forms/license-forms.html",
                    controller: "InternalLicenseForms",
                    params: {
                        id: null,
                        license: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.forms.packages", {
                    url: "/license/:id/packages",
                    templateUrl: paths.app + "licenses/components/license-packages/license-packages.html",
                    controller: "InternalLicensePackages",
                    params: {
                        id: null,
                        license: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })

            .state("internal.licensing.license.form", {
                abstract: true,
                templateUrl: paths.app + "licenses/components/license-form/license-form.html",
                controller: "InternalLicenseForm",
                params: {
                    id: null,
                    license: null,
                    formID: null,
                    form: null
                }
            })
                //Form Builder
                .state("internal.licensing.license.form.builder", {
                    url: "/license/:id/form/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-builder/license-form-builder.html",
                    controller: "InternalLicenseFormBuilder",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.formID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                //Form Permissions
                .state("internal.licensing.license.form.permissions", {
                    url: "/license/:id/permissions/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-permissions/license-form-permissions.html",
                    controller: "InternalLicenseFormPermissions",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "add";
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                //Form Triggers
                .state("internal.licensing.license.form.triggers", {
                    url: "/license/:id/form/triggers/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-triggers/license-form-triggers.html",
                    controller: "InternalLicenseFormTriggers",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: [ "$state", "$rootScope", "Permissions", function ($state, $rootScope,Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "add";
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                //Form Conditions
                .state("internal.licensing.license.form.conditions", {
                    url: "/license/:id/conditions/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-conditions/license-form-conditions.html",
                    controller: "InternalLicenseFormConditions",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.form.condition", {
                    url: "/license/:id/condition/:formID/:conditionID",
                    templateUrl: paths.app + "licenses/components/license-form-condition/license-form-condition.html",
                    controller: "InternalLicenseFormCondition",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null,
                        conditionID: null,
                        condition: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.conditionID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                //Form PDF
                .state("internal.licensing.license.form.pdf", {
                    url: "/license/:id/pdf/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-pdf/license-form-pdf.html",
                    controller: "InternalLicenseFormPDF",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                //Form Preview
                .state("internal.licensing.license.form.preview", {
                    url: "/license/:id/preview/:formID",
                    templateUrl: paths.app + "licenses/components/license-form-preview/license-form-preview.html",
                    controller: "InternalLicenseFormPreview",
                    params: {
                        id: null,
                        license: null,
                        formID: null,
                        form: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ( $state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })

            .state("internal.licensing.license.package", {
                url: "/license/:id/package/:packageID",
                templateUrl: paths.app + "licenses/components/license-package/license-package.html",
                controller: "InternalLicensePackage",
                params: {
                    id: null,
                    license: null,
                    packageID: null,
                    license_package: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.packageID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.licensing.license.forms").then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })

            //Triggers
            .state("internal.licensing.license.triggers", {
                abstract: true,
                templateUrl: paths.app + "licenses/layouts/license-triggers.html"
            })
            .state("internal.licensing.license.triggers.triggers", {
                url: "/license/:id/triggers/:triggerConfigurationID",
                templateUrl: paths.app + "licenses/components/license-triggers/license-triggers.html",
                controller: "InternalLicenseTriggers",
                params: {
                    id: null,
                    license: null,
                    triggerConfigurationID: null,
                    trigger_configuration: null
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })
                .state("internal.licensing.license.triggers.history", {
                    url: "/license/:id/triggers/history/:triggerConfigurationID",
                    templateUrl: paths.app + "licenses/components/license-triggers-history/license-triggers-history.html",
                    controller: "InternalLicenseTriggersHistory",
                    params: {
                        id: null,
                        license: null,
                        triggerConfigurationID: null,
                        trigger_configuration: null
                    },
                    resolve: {
                        permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })

            //Charges
            .state("internal.licensing.license.charges", {
                url: "/license/:id/charges",
                templateUrl: paths.app + "licenses/components/license-charges/license-charges.html",
                controller: "InternalLicenseCharges",
                params: {
                    id: null,
                    license: null
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.licensing.license.charge", {
                url: "/license/:id/charge/:licenseChargeID",
                templateUrl: paths.app + "licenses/components/license-charge/license-charge.html",
                controller: "InternalLicenseCharge",
                params: {
                    id: null,
                    license: null,
                    licenseChargeID: null,
                    license_charge: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.licenseChargeID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.licensing.license.charges").then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })

            //Scheduled Tasks 
            .state("internal.licensing.license.scheduledtasks", {
                url: "/license/:id/scheduledTasks/:licenseCategoryID",
                templateUrl: paths.app + "licenses/components/license-scheduledtasks/license-scheduledtasks.html",
                controller: "InternalLicenseScheduledTasks",
                params: {
                    id: null,
                    license: null,
                    licenseCategoryID: null,
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })
            .state("internal.licensing.license.scheduledtask", {
                abstract: true,
                templateUrl: paths.app + "licenses/components/license-scheduledtask/license-scheduledtask.html",
                controller: "InternalLicenseScheduledTask",
                params: {
                    id: null,
                    license: null,
                    licenseCategoryID: null,
                    scheduledTask: null,
                    scheduledTaskID: null
                }
            })
                .state("internal.licensing.license.scheduledtask.details", {
                    url: "/license/:id/scheduledTask/:scheduledTaskID/details/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-scheduledtask-details/license-scheduledtask-details.html",
                    controller: "InternalLicenseScheduledTaskDetails",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null,
                        scheduledTask: null,
                        scheduledTaskID: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.scheduledTaskID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.scheduledtasks").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.scheduledtask.logs", {
                    url: "/license/:id/scheduledTask/:scheduledTaskID/logs/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-scheduledtask-logs/license-scheduledtask-logs.html",
                    controller: "InternalLicenseScheduledTaskLog",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null,
                        scheduledTask: null,
                        scheduledTaskID: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.scheduledTaskID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.scheduledtasks").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.scheduledtask.log", {
                    url: "/license/:id/scheduledTask/:scheduledTaskID/log/:scheduledTaskLogID/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-scheduledtask-log/license-scheduledtask-log.html",
                    controller: "InternalLicenseScheduledTaskLog",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null,
                        scheduledTask: null,
                        scheduledTaskID: null,
                        scheduledTaskLog: null,
                        scheduledTaskLogID: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.scheduledTaskID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.scheduledtasks").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })
                .state("internal.licensing.license.scheduledtask.preview", {
                    url: "/license/:id/scheduledTask/:scheduledTaskID/preview/:licenseCategoryID",
                    templateUrl: paths.app + "licenses/components/license-scheduledtask-preview/license-scheduledtask-preview.html",
                    controller: "InternalLicenseScheduledTaskPreview",
                    params: {
                        id: null,
                        license: null,
                        licenseCategoryID: null,
                        scheduledTask: null,
                        scheduledTaskID: null
                    },
                    resolve: {
                        permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            var method = "view";
                            if ($stateParams.scheduledTaskID == null) {
                                method = "add";
                            }
                            return Permissions[method]("internal.licensing.license.scheduledtasks").then(function (access) {
                                if (!access) {
                                    $state.go("internal.licensing.denied");
                                }
                            });
                        }]
                    }
                })

            //History
            .state("internal.licensing.license.history", {
                url: "/license/:id/history",
                templateUrl:
                    paths.app +
                    "licenses/components/license-history/license-history.html",
                controller: "InternalLicenseHistory",
                params: {
                    id: null,
                    license: null
                },
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.licensing.denied");
                            }
                        });
                    }]
                }
            })
    }
]);
